import { render, staticRenderFns } from "./NewsletterSignupBar.vue?vue&type=template&id=a49bfaae&scoped=true&"
import script from "./NewsletterSignupBar.vue?vue&type=script&lang=ts&"
export * from "./NewsletterSignupBar.vue?vue&type=script&lang=ts&"
import style0 from "./NewsletterSignupBar.vue?vue&type=style&index=0&id=a49bfaae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49bfaae",
  null
  
)

export default component.exports